<div class='poam-component' style='height: 100%'>
  <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">
    <div>
      <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif; margin: 10px 10px 10px 10px">Internal Assessment View</h2>
    </div>

    <div style="display: flex; flex-direction: row; margin-top: 6px;margin-bottom: 10px;align-items:center;">

      <button mat-raised-button
              style="border-radius: 6px;margin-right: 10px;white-space: nowrap; "
              class="button" [routerLink]="['/projects', 'project', projectId]">
        Back to project
      </button>
    </div>
  </div>

  <p-table [value]="assessmentNotes"
           #poamTable
           [style]="{'font-size': '0.8em'}"
           [rows]="100"
           [reorderableColumns]="true"
           [paginator]="true"
           [pageLinks]="3"
           sortField="complianceAreaControlId"
           sortOrder="descending"
           [rowsPerPageOptions]="[10, 20, 50, 100]"
           [resizableColumns]="true"
           [metaKeySelection]="false"
           exportFilename="POAM"
           [columns]="cols">

    <ng-template pTemplate="caption">
      <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center">
        <div>
          <mat-form-field>
            <mat-label>From Date</mat-label>
            <input matInput
                   [matDatepicker]="fromDatePicker"

                   name="identificationDate"
                   [(ngModel)]="fromDate"
                   required>

            <mat-datepicker-toggle matSuffix [for]="fromDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #fromDatePicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field>
            <mat-label>To Date</mat-label>
            <input matInput
                   [matDatepicker]="toDatePicker"

                   name="identificationDate"
                   [(ngModel)]="toDate"
                   required>

            <mat-datepicker-toggle matSuffix [for]="toDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #toDatePicker></mat-datepicker>
          </mat-form-field>

          <button
            pButton
            class="risksponge-button"
            label="Show"
            (click)="filter()">
          </button>
        </div>


        <div>
          <button type="button"
                  pButton
                  class="risksponge-button"
                  icon="pi pi-file-excel"
                  iconPos="left"
                  (click)="poamTable.exportCSV()">
          </button>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
        <th *ngFor="let col of cols" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width || 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                      ariaLabelDesc="Activate to sort in descending order"
                      ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        </th>
      </tr>
      <tr>
        <th *ngFor="let col of cols" [ngSwitch]="col.field">
          <input *ngSwitchDefault pInputText type="text" placeholder="⌕"
                 (input)="poamTable.filter($event.target['value'], col.field, 'contains')">
          <span *ngSwitchCase="'dueDate'"></span>
        </th>

      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
      <tr [pSelectableRow]="item">
        <td *ngFor="let col of cols" [ngSwitch]="col.field">
          <span *ngSwitchDefault>{{item[col.field]}}</span>
          <span *ngSwitchCase="'date'">{{item[col.field] | date:'shortDate'}}</span>
          <span *ngSwitchCase="'actionPlansText'">
            <ul style="padding-left: 2em;">
              <li *ngFor="let actionPlan of item.actionPlans">{{actionPlan.weaknessDescription}}</li>
              </ul>
          </span>
        </td>
      </tr>
    </ng-template>


  </p-table>
</div>
